import { render } from "./ImpactSection.vue?vue&type=template&id=a2903eaa&scoped=true"
import script from "./ImpactSection.vue?vue&type=script&lang=js"
export * from "./ImpactSection.vue?vue&type=script&lang=js"

import "./ImpactSection.vue?vue&type=style&index=0&id=a2903eaa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2903eaa"]])

export default __exports__